/**
 * Login / Forgot / Reset left-column marketing copy.
 * Standard copy is the platform default (apex and tenants without a custom entry).
 * Per-tenant overrides are keyed by Account.site_name (subdomain prefix), e.g. "ta".
 */

/** @typedef {{ kind: 'rich' }} RichKind — rendered by StandardLoginMarketingAside */
/** @typedef {{ kind: 'simple', headline: string, paragraphs: Array<{ lead?: string, body: string }> }} SimpleKind */

/** Sentinel: use the built-in platform narrative (rich JSX). */
export const STANDARD_LOGIN_MARKETING = Object.freeze({ kind: "rich" });

/** Top Achievers Foundation — ta.allthingsdue.com */
export const TA_COMPASS_LOGIN_MARKETING = Object.freeze({
  kind: "simple",
  headline: "Welcome to COMPASS",
  paragraphs: [
    {
      lead: "COMPASS is the official family portal for Top Achievers Foundation.",
      body: " It gives parents and students one convenient place to stay connected to everything happening throughout the year.",
    },
    {
      body: "COMPASS is your family's connection to Top Achievers Foundation. From program registration and event check-ins to important updates and student records, everything you need is in one secure place.",
    },
    {
      body: "Our mission is to inspire, transform, and empower students to live a lifestyle of high achievement. COMPASS helps us deliver an exceptional experience for every family while keeping you connected to opportunities all year long.",
    },
  ],
});

/**
 * Custom marketing by site_name (subdomain slug). Add new tenants here.
 * @type {Readonly<Record<string, typeof TA_COMPASS_LOGIN_MARKETING>>}
 */
export const LOGIN_MARKETING_BY_SITE = Object.freeze({
  ta: TA_COMPASS_LOGIN_MARKETING,
});

/**
 * Resolve marketing content for a tenant subdomain (or null/undefined for apex).
 * @param {string | null | undefined} siteName
 * @returns {typeof STANDARD_LOGIN_MARKETING | typeof TA_COMPASS_LOGIN_MARKETING}
 */
export function getLoginMarketingContent(siteName) {
  const key = typeof siteName === "string" ? siteName.trim().toLowerCase() : "";
  if (key && LOGIN_MARKETING_BY_SITE[key]) {
    return LOGIN_MARKETING_BY_SITE[key];
  }
  return STANDARD_LOGIN_MARKETING;
}
